'use client';

import { c as _c } from "react/compiler-runtime";
import styles from './UserAvatar.module.css';
import { type ClerkUser, getUserInitial } from './userIdentity';
type UserAvatarProps = {
  readonly user: ClerkUser;
};

/**
 * The photo-or-initial choice in one place, so the trigger's 36px badge and the panel's 56px
 * profile block can't drift apart. Both inherit their size and font from their container.
 */
export const UserAvatar = t0 => {
  const $ = _c(6);
  const {
    user
  } = t0;
  if (user.imageUrl) {
    let t1;
    if ($[0] !== user.imageUrl) {
      t1 = <img src={user.imageUrl} alt="" className={styles.image} />;
      $[0] = user.imageUrl;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== user) {
    t1 = getUserInitial(user);
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <span className={styles.initial} aria-hidden="true">{t1}</span>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};